import React from 'react';

import { Redirect } from 'react-router-dom';

import ConfirmChangeDefaultWallet from 'pages/ConfirmChangeDefaultWallet/ConfirmChangeDefaultWallet.jsx';
import DepositAccruals from 'pages/DepositAccruals/DepositAccruals.jsx';
import IncomeCalculator from 'pages/IncomeCalculator/IncomeCalculator.jsx';
import Investments from 'pages/Investments/Investments.jsx';
import Metrics from 'pages/Metrics/Metrics.jsx';
import NotificationsList from 'pages/Notifications';
import AdminNotifications from 'pages/Notifications/Admin/AdminNotifications.jsx';
import NotificationCreate from 'pages/Notifications/Admin/CreateNotification/NotificationCreate.jsx';
// import Withdraw from "pages/Withdraw"
import Projects from 'pages/Projects';
import Promotion from 'pages/Promotion/Promotion.jsx';
import ReferralAccruals from 'pages/ReferralAccurals/ReferralAccruals.jsx';
import SupportPage from 'pages/Support/SupportPage';
import TicketPage from 'pages/Support/TicketPage';
import Team from 'pages/Team/Team';
import TeamStructure from 'pages/TeamStructure/TeamStructure.jsx';

import AccountRecovery from '../pages/Authentication/AccountRecovery.jsx';
import SetPassword from '../pages/Authentication/SetPassword.jsx';
import EmailVerification from '../pages/Authentication/EmailVerification.jsx';
import ForgetPwd from '../pages/Authentication/ForgetPassword.jsx';
// Authentication related pages
import Login from '../pages/Authentication/Login.jsx';
import Logout from '../pages/Authentication/Logout';
import RecoverPwd from '../pages/Authentication/RecoverPassword.jsx';
import Register from '../pages/Authentication/Register.jsx';
// Maybe will be need
import LockScreen from '../pages/AuthenticationInner/auth-lock-screen';
// import TwostepVerification from "../pages/AuthenticationInner/auth-two-step-verification"
// import TwostepVerification2 from "../pages/AuthenticationInner/auth-two-step-verification-2"
// Dashboard
import Dashboard from '../pages/Dashboard/index';
import Deposit from '../pages/Deposit';
import InvestmentAnalyze from '../pages/InvestmentAnalyze';
import NotificationsTypes from '../pages/Notifications/NotificationsTypes';
import PrivacyPolicy from '../pages/PrivacyPolicy/PrivacyPolicy';
import TotalAccrualsPage from '../pages/TotalAccrualsPage';
// Profile
import UserProfileSetting from '../pages/UserProfileSetting';
import Pages404 from '../pages/Utility/pages-404';
import Pages500 from '../pages/Utility/pages-500';
import PagesComingsoon from '../pages/Utility/pages-comingsoon';
import PagesMaintenance from '../pages/Utility/pages-maintenance';

const authProtectedRoutes = (isAdmin) => [
  { path: '/dashboard', component: Dashboard },
  { path: '/deposit', component: Deposit },
  // { path: "/withdraw", component: Withdraw },
  // { path: '/team', component: Team },
  { path: '/notifications', component: NotificationsList },
  {
    path: '/investments',
    component: Investments,
  },
  { path: '/investments-analyzing', component: InvestmentAnalyze },
  {
    path: '/accruals/deposit',
    component: DepositAccruals,
  },
  {
    path: '/accruals/referral',
    component: ReferralAccruals,
  },
  {
    path: '/accruals',
    component: TotalAccrualsPage,
  },

  // //profile
  { path: '/profile', component: UserProfileSetting },

  // {
  //   path: '/calculator',
  //   component: IncomeCalculator,
  // },
  //Invoices

  //Projects
  // { path: '/projects/:type', component: Projects },
  // { path: "/projects/:type/:slug", component: Project },
  //   TODO temporarily disabled
  // { path: '/admin/metrics', component: Metrics },

  {
    path: '/team/structure/:partnerId',
    component: TeamStructure,
  },

  {
    path: '/notifications/create',
    component: isAdmin ? NotificationCreate : () => <Redirect to="/notifications" />,
  },
  {
    path: '/notifications/edit/:notificationId',
    component: isAdmin ? NotificationCreate : () => <Redirect to="/notifications" />,
  },
  {
    path: '/notifications/types',
    component: NotificationsTypes,
  },
  {
    path: '/support',
    component: SupportPage,
  },
  {
    path: '/support/ticket/:id',
    component: TicketPage,
  },
  // {
  //   path: '/promotion',
  //   component: Promotion,
  // },

  //Utility
  // { path: "/pages-starter", component: PagesStarter },
  // { path: "/pages-timeline", component: PagesTimeline },
  // { path: "/pages-faqs", component: PagesFaqs },
  // { path: "/pages-pricing", component: PagesPricing },

  // this route should be at the end of all other routes
  { path: '*', exact: true, component: () => <Redirect to="/dashboard" /> },
];

const publicRoutes = [
  { path: '/logout', component: Logout },
  { path: '/login', component: Login },
  { path: '/forgot-password', component: ForgetPwd },
  { path: '/account-recovery', component: AccountRecovery },
  { path: '/account-recovery/set-password', component: SetPassword },
  { path: '/deposit', component: Deposit },
  // { path: '/register', component: Register }, //hide register
  { path: `/password-change`, component: RecoverPwd },
  { path: '/confirm-email', component: EmailVerification },
  {
    path: '/change-default-wallet/:hash',
    component: ConfirmChangeDefaultWallet,
  },
  { path: '/privacy_policy', component: PrivacyPolicy },
  { path: '/pages-maintenance', component: PagesMaintenance },
  { path: '/pages-comingsoon', component: PagesComingsoon },
  { path: '/pages-404', component: Pages404 },
  { path: '/pages-500', component: Pages500 },

  // Authentication Inner
  { path: '/auth-lock-screen', component: LockScreen },
];

export { authProtectedRoutes, publicRoutes };
